export default __webpack_public_path__ + "static/karolinawilk-96a26ddd852a9dfcbd1ac2750bd13c26.jpeg";